import { EAbTestingGroup } from '@/enums/ab-testing';

export const namespace = 'onboarding';

export enum EOnboardingAction {
  SetOnboardingGroup = 'setOnboardingGroup',
  SetSentFirstDocument = 'setSentFirstDocument',
  ToggleOnboardingSidebar = 'toggleOnboardingSidebar',
}

export enum EOnboardingMutation {
  OnboardingGroup = 'onboardingGroup',
  SetSentFirstDocument = 'setSentFirstDocument',
  ShowSidebar = 'showSidebar',
}
export enum EOnboardingGetter {
  AddedDocument = 'addedDocument',
  AddedRecipient = 'addedRecipient',
  AddedEngageVideo = 'addedEngageVideo',
  SentDocument = 'sentDocument',
  ShowOnboarding = 'showOnboarding',
}

export interface IOnboardingState {
  onboardingGroup: EAbTestingGroup;
  hasSentFirstDocument: boolean;
  showSidebar: boolean;
}

export const state: IOnboardingState = {
  onboardingGroup: EAbTestingGroup.Unaltered,
  hasSentFirstDocument: false,
  showSidebar: false,
};
